export default "__VITE_PUBLIC_ASSET__96e29de7__"